import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import {
  LubavSessionType,
  OfficeHoursSessionType,
  SolutionSessionId,
  OFFICE_HOURS_SESSION_TYPES,
  SOLUTION_SESSION_IDS,
  LubavSupersession,
  LUBAV_SUPERSESSIONS,
} from '@backrs_ui/grow-ui/src/models/models';

import { initialState as boxDataInitialState } from '../boxData/boxData';
import { initialState as coachLubavInitialState } from '../coachLubav/coachLubav';
import { initialState as solutionSessionInitialState } from '../solutionSession/solutionSession';
import { RootState } from '../store';

// helper to create a session-specific action
export const createSessionAction = <T>(
  actionCreator: ActionCreatorWithPayload<T>,
  sessionType: LubavSessionType | null,
) => {
  return (payload: T) => ({
    ...actionCreator(payload),
    sessionType,
  });
};

// helper to get session-specific state from the root state
export const getSessionState = (state: RootState, sessionType: LubavSessionType | null) => {
  // If the session doesn't exist yet, return initial state structure
  if (!sessionType || !state.sessionState.sessions[sessionType]) {
    return {
      coachLubav: coachLubavInitialState,
      boxData: boxDataInitialState,
      solutionSession: solutionSessionInitialState,
    };
  }

  return state.sessionState.sessions[sessionType];
};

// helper to get the active session type
export const getActiveLubavSession = (state: RootState) => {
  return state.sessionState.activeSessionType;
};

export const typeGuardForSolutionSessionId = (
  sessionName: LubavSessionType,
): sessionName is SolutionSessionId => {
  return Object.values(SOLUTION_SESSION_IDS).includes(sessionName as SolutionSessionId);
};

export const typeGuardForOfficeHoursSessionType = (
  sessionName: LubavSessionType,
): sessionName is OfficeHoursSessionType | LubavSupersession => {
  return (
    Object.values(OFFICE_HOURS_SESSION_TYPES).includes(sessionName as OfficeHoursSessionType) ||
    Object.values(LUBAV_SUPERSESSIONS).includes(sessionName as LubavSupersession)
  );
};
